import { Box, Flex, Text, TextLink } from '@updater/ui-uds';
import { Events, useTracking } from 'services';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useAcceptUpdaterTerms } from 'hooks';
import { TermsAndPrivacyDisclaimer } from 'components/TermsAndPrivacyDisclaimer';
import { PageRoutes } from 'constants/pageRoutes';

const ALL_PLANS = 'all plans';

export function SkipLinkWithDisclaimer() {
  const router = useRouter();
  const tracking = useTracking();
  const acceptUpdaterTerms = useAcceptUpdaterTerms();

  const onSkipLinkClick = useCallback(() => {
    // https://updater.atlassian.net/jira/software/c/projects/TVI/boards/541?assignee=60bbd7523aa6050068a5fca0&selectedIssue=TVI-244
    acceptUpdaterTerms();
    tracking.trackEvent(Events.SKIP_QUESTIONS, 'clicked');
    router.push(PageRoutes.plans);
    return true;
  }, [acceptUpdaterTerms, tracking, router]);

  return (
    <Box>
      <Flex mb="s">
        <Text variant="m">
          Skip and show me{' '}
          <TextLink
            data-testid="showPlansLink"
            showTextDecoration
            onClick={onSkipLinkClick}
          >
            {ALL_PLANS}
          </TextLink>{' '}
          in my area.
        </Text>
      </Flex>
      <Flex mb="s">
        <TermsAndPrivacyDisclaimer
          prefix={`By clicking "Continue" or "${ALL_PLANS}",`}
        />
      </Flex>
    </Box>
  );
}
